import { FormEvent, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import ResumoDoPedido from "../../components/Carrinho/ResumoDoPedido";
import AplicarCupom, { CupomProps } from "../../components/Carrinho/AplicarCupom";
import Seta from "../../assets/SetaDireita.svg";
import styles from "./ConfirmOrder.module.css";
import ProdutoItem from "../../components/Carrinho/Itens";
import { Produto } from "../../components/CardProduto/CardProduto";
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";

interface Cart {
    id: string;
    product: Produto;
    amount: number;
}

function ConfirmOrder() {
    const navigate = useNavigate();
    const location = useLocation()
    const { changeNOrders, nOrders } = useCart()
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [carts, setCarts] = useState<Cart[]>([]);
    const [voucher, setVoucher] = useState<CupomProps>(
        location.state?.voucher ?? { name: "", discount: 0, valid: false }
    );
    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
    const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
      window.innerWidth < 768
    );
  
    function handleWindowSizeChange() {
      setIsSmallScreen(window.innerWidth < 768);
    }
  
    useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      // Executar uma vez no início para garantir que o estado é atualizado com a largura da janela atual
      handleWindowSizeChange();
  
      return () => window.removeEventListener('resize', handleWindowSizeChange);
    }, []);

    const {
        address,
        delivery,
        paymentSelected,
        freight,
        dateDelivery,
        cardId,
        cardToken,
        paymentMethodId,
        installments,
        cvv,
    } = location.state || {}

    console.log(delivery)

    useEffect(() => {
        const handleResize = () => {
            setLarguraTela(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //TODO: pegar do token do usuario logado

    const clientId = localStorage.getItem('clientId');
    useEffect(() => {

        const getClientCart = async () => {
            const newCarts = await api.get<Cart[]>(`/cart/client/${clientId}`);
            console.log(newCarts.data);
            setCarts(newCarts.data);
            setProdutos(
                newCarts.data.map((cart: any) => {
                    return {
                        ...cart.product,
                        quantidadePedido: cart.amount,
                    };
                })
            );
        };
        getClientCart();

    }, []);

    const updateItem = async (produtoId: string, qtd: number) => {
        const oldCart = carts.find((cart) => cart.product.id === produtoId);
        if (!oldCart) return null;
        if (qtd > oldCart.product.quantity) {
            alert("Quantidade de item maior do que o estoque");
            return null;
        }
        try {
            await api.put(`/cart/${oldCart.id}`, {
                clientId: localStorage.getItem("clientId"),
                productId: produtoId,
                amount: qtd,
                status: "EM ABERTO",
            });
            setCarts((prev) =>
                prev.map((cart) =>
                    cart.product.id === produtoId ? { ...cart, amount: qtd } : cart,
                ),
            );
            setProdutos((prev) =>
                prev.map((produto) =>
                    produto.id === produtoId
                        ? { ...produto, quantidadePedido: qtd }
                        : produto,
                ),
            );
            return true;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    const handleSubmitShopping = async (event: FormEvent) => {
        event.preventDefault();

        const hasInvalidQuantity = carts.some((cart) => {
            const product = produtos.find((p) => p.id === cart.product.id);
            return product && cart.amount > product.quantity;
        });

        if (hasInvalidQuantity) {
            alert("A quantidade de um ou mais produtos excede o estoque disponível.");
            return;
        }

        try {
            const newOrder = await api.put(`/cart/close/${clientId}?voucher=${voucher.valid ? voucher.name : ''}`, {
                addressId: address.id,
                freight,
                paymentMethod: paymentSelected,
                typeDelivery: delivery,
                freightDate: dateDelivery,
                cvv,
                cardToken: cardToken ?? '',
                paymentMethodId: paymentMethodId ?? '',
                cardId: cardId ?? '',
                installments
            });

            // Atualiza a quantidade de produtos no estoque

            // const updateProductQuantities = async () => {
            //     console.log("Debug newOrder.data:", newOrder.data);
            //     if (newOrder.data && Array.isArray(newOrder.data)) {
            //         console.log("Entrou no for principal"); // Verifica se entrou na condição
            //         for (const orderData of newOrder.data) {
            //             if (orderData.product_order && Array.isArray(orderData.product_order)) {
            //                 await Promise.all(
            //                     orderData.product_order.map(async (order: Order) => {
            //                         const newQuantity = order.product.quantity - order.amount;
            //                         const payload = {
            //                             quantity: newQuantity,
            //                         };
            //                         await api.put(`/product/${order.product.id}`, payload);
            //                     })
            //                 );
            //             } else {
            //                 console.error("product_order is undefined or not an array", orderData);
            //             }
            //         }
            //     } else {
            //         console.error("newOrder.data is not an array or is undefined", newOrder.data);
            //     }
            // };


            // await updateProductQuantities();

            // Deleta todos os carrinhos do cliente
            // for (const cart of carts) {
            //     await api.delete(`/cart/${cart.id}`);
            // }
            changeNOrders(0)
            navigate("/Comprafinalizada", {
                state: {
                    qr_code_base64: newOrder.data.payment.qr_code_base64,
                    qr_code: newOrder.data.payment.qr_code,
                    date_created: newOrder.data.payment.date_created,
                    date_of_expiration: newOrder.data.payment.date_of_expiration,
                    amount: newOrder.data.payment.amount,
                    typePayment: paymentSelected,
                    orderId: newOrder.data.order_id
                }
            });
        } catch (error) {
            console.log(error)
            alert('Erro ao fazer pedido. Por favor, tente mais tarde');
        }
    };

    const { t } = useTranslation();
    return (
        <div>
            <Header
                boxShadow
                mobileMenuActiveState={isMobileMenuVisible}
                toggleMobileMenu={setIsMobileMenuVisible}
                isSmallScreen={isSmallScreen}
                hamburgerIcon={false}
            />
            <div className={styles.caminho}>
                <div className={styles.item}>
                    <a href="/">{t("carrinho.paginaInicial")}</a>
                </div>
                <div className={styles.img_setacarrinho}>
                    <img className={styles.imagem_setacarrinho} src={Seta} alt="seta" />
                </div>
                <div className={styles.local}>
                    <span>{t("carrinho.carrinho")}</span>
                </div>
            </div>
            <div className={styles.titulo}>
                <p className={styles.titulocarrinho}>{t("carrinho.carrinho")}</p>
            </div>

            <div className={styles.carrinho_geral}>
                <form
                    className={styles.carrinho_container}
                    onSubmit={handleSubmitShopping}
                >
                    <ul className={styles.product_list}>
                        {produtos.map((produto) => (
                            <li key={produto.id} className={styles.product_item}>
                                <ProdutoItem
                                    key={produto.id}
                                    produto={produto}
                                    screenSize={larguraTela}
                                    dateDelivery={dateDelivery}
                                    delivery={delivery}
                                    amount={
                                        carts.find((cart) => cart.product.id === produto.id)
                                            ?.amount ?? produto.quantidadePedido ?? 0
                                    }
                                    onUpdate={updateItem}
                                />
                            </li>
                        ))}
                    </ul>
                    <div className={styles.resumo}>
                        <p className={styles.tituloresumo}>{t("carrinho.resumo")}</p>
                        <p className={styles.descresumo}>{t("carrinho.descresumo")}</p>
                        <div className={styles.aplicarcupom}>
                            <AplicarCupom voucher={voucher} setVoucher={setVoucher} />
                        </div>
                        <ResumoDoPedido
                            produtos={produtos}
                            voucher={voucher}
                            freight={freight}
                        />
                        <span>{paymentSelected}</span>
                        <div className={styles.finalcarrinho}>
                            <button type="submit" className={styles.conc}>
                                <strong>{t("carrinho.concluir")}</strong>
                            </button>
                            <a className={styles.continuar} href="/">
                                {t("carrinho.continuar")}
                            </a>
                        </div>
                    </div>
                </form>
            </div>
            {!isSmallScreen && (<Footer />)}
        </div>
    );
}

export default ConfirmOrder;
